export enum Integrations {
  PANEL = 'panel',
  SHOPER = 'shoper',
  SHOPIFY = 'shopify',
  PIPEDRIVE = 'pipedrive',
  ALLEGRO = 'allegro',
  ZAPIER = 'zapier',
  BASELINKER = 'baselinker',
  PRESTASHOP = 'prestashop',
  ERECRUITER = 'erecruiter',
  APILO = 'apilo',
  CUSTOM = 'custom',
}
